export default {
  switchAccount: "Konto wechseln",
  login: "Einloggen",
  loginFirst: "Bitte zuerst einloggen",
  start: "Start",
  hasHistory: "Einige der Fragen hast du bereits beantwortet.",
  loadHistory: "Möchtest du fortfahren?",
  cancel: "Nein",
  confirm: "Ja",
  contact: "Hinterlasse deine Kontaktdaten, um Bonusbelohnungen zu gewinnen!",
  completed: "Du hast die Umfrage abgeschlossen.",
  leaveMessage:
    "Hinterlasse deine Kontaktdaten, um Bonusbelohnungen zu gewinnen!",
  enterEmail: "E-Mail:",
  enterPhone: "Telefon:",
  submit: "Einreichen",
  leave: "Verlassen",
  submitted: "Eingereicht",
  thanks: "Danke!",
  opinion: "Was ist deine Meinung?",
  prev: "Vorher",
  next: "Weiter",
  unlikely: "Sehr unwahrscheinlich",
  likely: "Sehr wahrscheinlich",
  claimYourRewards: "Du kannst deine Belohnungen abholen.",
  rewardSent: "Belohnungen gesendet.",
  checkInGame: "Bitte hole sie im Spiel ab.",
  copy: "Kopieren",
  copied: "Kopiert",
  selectTips: "Bitte wähle die beste Antwort aus.",
  multipleTips: "Du kannst mehrere Antworten auswählen.",
  leastChoose: "Wähle bis zu xxx Antworten aus",
  maxChoose: "Wähle mindestens xxx Antworten aus.",
  mustAnswer: "Bitte beantworte zuerst die aktuelle Frage.",
  mustWrite: "Bitte schreibe etwas.",
  checkEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
  checkPhone: "Bitte gib eine gültige Telefonnummer ein.",
  isAnswer: "Du hast bereits die Umfrage ausgefüllt.",
  unStart: "Event nicht verfügbar",
  end: "Event ist vorbei",
  server: "Wähle deinen Server",
  role: "Wähle deinen Charakter",
  common: "System ist beschäftigt. Versuche es später erneut.",
  title: "Fragebogen",
  titleAward: "Umfrage",
  leastWord: "Bitte gib mindestens xxx Zeichen ein.",
  maxWord: "Zeichenbegrenzung (xxx) überschritten!",
  singleChoose: "Einzelantwort",
  multiChoose: "Mehrfachantwort",
  matrix: "Matrixfrage",
  score: "Bewertung",
  textLimit: "(xx-yyy Charaktere)",
  coverGiftTitle: "Schließe die Umfrage ab, um Geschenk abzuholen",
  "-20001": "Nicht eingeloggt",
  "-20002": "Erforderliche Parameter fehlen",
  "-20003": "Umfrage nicht gefunden",
  "-20004": "Umfrage wird konfiguriert",
  "-20005": "Umfrage gestoppt",
  "-20006": "Umfrage-Event nicht gestartet",
  "-20007": "Umfrage-Event beendet",
  "-20008": "Bereits beantwortet",
  "-20010": "Belohnungsverteilung fehlgeschlagen",
  "-20011": "Belohnung für diese Umfrage bereits verteilt",
  "-20012": "Noch nicht beantwortet",
  "-20016": "Ungültige Spiel-ID",
};
